import React, {useContext} from "react";
import Image1 from "../../assets/images/hotal-1.png";
import "./style.scss";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getSearchFilters} from "../../redux/slices/searchFilterSlice";
import {
    getAnywhereSearchExpediaUrl,
    getCurrencyBadge,
    getListingItemFilters,
    handleFavoriteHotelItem,
    navigateToDetailPage,
    openExternalLink,
} from "../../helpers/common";
import {getAppConfig} from "../../redux/slices/appconfigSlice";
import {getLoginConfig} from "../../redux/slices/loginconfigSlice";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faHeart,
    faMapMarkerAlt,
    faStar,
    faChevronUp,
    faChevronDown,
} from "@fortawesome/pro-solid-svg-icons";
import {AccordionContext, useAccordionButton} from "react-bootstrap";
import PropTypes from "prop-types";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

const HotelItemDetailMap = ({offer, index, handler = null, handlerOnBack = null}) => {
    console.log({offer, index});
    const {T} = useTranslationCustom();
    const appconfig = useSelector(getAppConfig);
    const loginconfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let currency = "$";
    const filters = getListingItemFilters(
        offer,
        T,
        offer?.objHotel?.newPackagedOffer?.flightOffer
    );

    const features = [
        {name: T('Filters:Map_Offer_Internet'), available: offer?.roomTypes[0]?.ratePlans[0]?.freeInternet || false},
        {name: T('Filters:Map_Offer_Wifi'), available: offer?.roomTypes[0]?.ratePlans[0]?.freeWiFi || false},
        {name: T('Filters:Map_Offer_Parking'), available: offer?.roomTypes[0]?.ratePlans[0]?.freeParking || false},
        {name: T('Filters:Map_Offer_Breakfast'), available: offer?.roomTypes[0]?.ratePlans[0]?.freeBreakfast || false},
    ];

    if (offer?.detailsLink) {
        const objUrl = new URL(offer?.detailsLink);
        const searchparams = new URLSearchParams(objUrl.search);
        currency = searchparams.get("currency");
    }

    function ContextAwareToggle({eventKey, callback}) {
        const {activeEventKey} = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey)
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <button type="button" className={"action-btn"} onClick={decoratedOnClick}>
                {isCurrentEventKey ? T("Buttons:View_Less") : T("Buttons:View_More")}{" "}
                <FontAwesomeIcon
                    icon={isCurrentEventKey ? faChevronUp : faChevronDown}
                />
            </button>
        );
    }

    ContextAwareToggle.propTypes = {
        eventKey: PropTypes.string.isRequired,
        callback: PropTypes.func,
    };

    return (
        <>
            <div className="sidebar-hotel-details-wrapper">
                <div className="top-buttons">
                    {/* <span className="fas fa-long-arrow-alt-left" onClick={handlerOnBack}></span> */}
                    <FontAwesomeIcon icon={faArrowLeftLong} className="arrow-left" onClick={handlerOnBack} />
                    <a
                        className="action-btn"
                        onClick={() => {
                            const expediaUrl = getAnywhereSearchExpediaUrl(offer, searchfilters);
                            if (expediaUrl) {
                                openExternalLink(expediaUrl);
                                return;
                            }
                            !offer?.detailsLink &&
                            navigateToDetailPage(
                                offer,
                                dispatch,
                                loginconfig,
                                searchfilters,
                                navigate,
                                "hotel",
                                true,
                                false,
                                false,
                                null, // Branch data null
                            );
                        }}
                    >
                        {T("Buttons:Full_Detail")}
                    </a>
                </div>

                <div className="small-card-content-holder">
                    <div className="d-flex justify-content-between">
                        <h4 className="heading heading-6 dark-text font-poppings ellipis" style={{ flex:1}}>
                            {offer?.name}
                        </h4>
                        <a
                            className="fav-icon"
                            onClick={(e) => {
                                e.stopPropagation();
                                handleFavoriteHotelItem(
                                    loginconfig,
                                    dispatch,
                                    searchfilters,
                                    offer,
                                    appconfig,
                                    index,
                                    null,
                                    offer?.objHotel?.newPackagedOffer?.flightOffer
                                );
                                if (handler) {
                                    handler(index);
                                }
                            }}
                        >
                            <FontAwesomeIcon
                                icon={faHeart}
                                className={offer?.favoriteGuid ? "favorite" : ""}
                            />
                        </a>
                    </div>
                    <div className="reviews">
                        <div className="star">
                            {[1, 2, 3, 4, 5].map((item, index) => {
                                if (item <= Number(offer?.starRating))
                                    return (
                                        <FontAwesomeIcon
                                            key={index}
                                            icon={faStar}
                                            className="filled"
                                        />
                                    );
                                else
                                    return (
                                        <FontAwesomeIcon
                                            key={index}
                                            icon={faStar}
                                            className="blank"
                                        />
                                    );
                            })}
                            <span>{`${offer?.guestRating || 0} (${offer?.guestReviewCount || 0})`}</span>
                        </div>
                    </div>
                    <p className="location">
                        <FontAwesomeIcon icon={faMapMarkerAlt}/>
                        {offer?.address || offer?.location}
                    </p>

                    <div className="d-flex justify-content-between align-items-end mb-3">
                        <ul className="info-tags">
                            {filters?.map((filter, index) => {
                                return (
                                    <li
                                        className="veryLight-bg fs-12 medium darkgray-color"
                                        key={index}
                                    >
                                        {filter.title}
                                    </li>
                                );
                            })}
                        </ul>
                        <div>
                            <p className="price-caption text-end">
                                {T("Home:Home_List_View_Total_Text")}
                            </p>
                            <div className="price-holder">
                                <div className="price">
                                    {getCurrencyBadge(
                                        offer?.perPersonPrice?.currency || currency
                                    )}
                                    {offer?.price && (
                                        <PriceBoxes
                                            price={Number(
                                                offer?.perPersonPrice?.totalPrice || offer?.price
                                            ).toFixed(0)}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <img
                        src={offer?.thumbnailUrl || offer?.hotelImg || Image1}
                        className="covered-image"
                        alt={"hotel-image"}
                    />
                    <div className="my-3">
                        <h4 className="heading heading-6 dark-text font-poppings ellipis">
                            {T('Filters:Map_Offer_Detail')}
                        </h4>
                        <p className="description">
                            {offer?.description &&
                                Object.keys(offer?.description)?.map((type, index) => {
                                    return <p key={index}>{offer?.description[type]}</p>;
                                })}
                        </p>
                        {/*<a className="readmore" href="#">More</a>*/}
                    </div>

                    <div>
                        <h4 className="heading heading-6 dark-text font-poppings ellipis">
                            {T('Filters:Map_Offer_Features')}
                        </h4>
                        <div className="features-tags">
                            {features.map((item, index) => (
                                <span key={index} className={item.available ? "" : "strike"}>{item.name}</span>
                            ))}
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
};

const PriceBoxes = ({price}) => {
    let value = price.toString().split("");
    let valueIndex = 0;
    let _price = [];
    for (let index = 0; index <= value.length; index++) {
        if (value.length && value[value.length - valueIndex]) {
            _price.unshift(value[value.length - valueIndex]);
        }
        valueIndex++;
    }

    return _price.map((digit, index) => <span key={index}>{digit}</span>);
};

PriceBoxes.propTypes = {
    price: PropTypes.string,
};

HotelItemDetailMap.propTypes = {
    offer: PropTypes.object,
    index: PropTypes.number,
    handler: PropTypes.func,
    handlerOnBack: PropTypes.func,
};

export default HotelItemDetailMap;
